import _regeneratorRuntime from "/root/app/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

import { useContext } from 'react';
import merge from 'lodash/merge';
import useSWR, { cache } from 'swr';
import { makeCacheKey, fetchData } from './utils';
import RootContext from './RootContext';
/**
 * this is a convenience hook to get data from an array of contexts
 * @param {Array<React.Context>} - contexts - the array of contexts to use data from
 * @return {Array<GenericFetchContextType>} - an array of all the context
 */

export function useContexts(contexts) {
  var contextData = [];

  for (var contextOn = 0; contextOn < contexts.length; contextOn++) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    contextData.push(useContext(contexts[contextOn]));
  }

  return contextData;
}
/**
 * @tyoe reduxCookFunctionType
 * The specific function signature for a function that "cooks" context data to data in the redux form
 */

/**
 * this is a convenience hook to get data from an array of contexts using an array of cook functions to cook
 * the data into a redux form compatible with existing Signal selectors
 * @param {Array<ContextCookerType>} - contextCookers - the array of contexts to pull data from and "cook
 *   function(s)" to un the contexts through to convert them to redux form
 * @return {Object} - the cooked data a form that can be passed to a redux selector
 */

export function useContextsInReduxForm(contextCookers) {
  var contextData = useContexts(contextCookers.map(function (_ref) {
    var context = _ref.context;
    return context;
  }));
  return contextCookers.reduce(function (selectorState, _ref2, contextOn) {
    var context = _ref2.context,
        cookers = _ref2.cookers;
    return cookers.reduce(function (_context, cooker) {
      return merge(cooker(contextData[contextOn]), _context);
    }, selectorState);
  }, {});
}
/**
 * @interface UseSWRWithCacheParams
 * this interface defines the set of parameters accepted by the useSWRWithCache hook
 */

/**
 * this is a wrapper hook around useSWR designed to be used for cacheable data fetching.  SWR has a cache but does
 * not use it to short-circuit requests, only for request de-duping.
 * @param {UseSWRWithCacheParams} - the parameters as defined in the interface above
 * @return {Promise} - a promise to receive the data
 */

export function useSWRWithCache(_ref3) {
  var _ref3$url = _ref3.url,
      url = _ref3$url === void 0 ? '' : _ref3$url,
      body = _ref3.body,
      context = _ref3.context,
      method = _ref3.method,
      fetchTimeout = _ref3.fetchTimeout,
      cacheBust = _ref3.cacheBust;

  var _useContext = useContext(RootContext),
      _useContext$fetcher = _useContext.fetcher,
      fetcher = _useContext$fetcher === void 0 ? window.fetch : _useContext$fetcher;

  var serializedBody = body && JSON.stringify(body);
  var cacheKey = makeCacheKey(url, serializedBody);

  var _useSWR = useSWR(cacheKey, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var cachedValue;
    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            cachedValue = cache.get(cacheKey);

            if (!cachedValue) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", cachedValue);

          case 5:
            console.log('[contextFetch] useSWRWithCache not cached', context, url, body);

          case 6:
            if (cacheBust) {
              url += "".concat(url.includes('?') ? '&' : '?', "cache_bust=").concat(Date.now());
            }

            _context2.next = 9;
            return fetchData({
              url: url,
              fetcher: fetcher,
              fetchTimeout: fetchTimeout,
              options: {
                body: serializedBody,
                method: method
              }
            });

          case 9:
            return _context2.abrupt("return", _context2.sent);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee);
  }))),
      data = _useSWR.data;

  return data;
}
export default useSWRWithCache;